<template>
  <div class="contain">
    <div class="rightbox" style="width: 100%">
      <div class="top-lists">
        <div class="nav-view styles">
          {{ $t("fn_124") }}
        </div>
      </div>
      <div class="contains">
        <div class="topbox" v-if="userInfo.pkCountry != 1">
          <el-form label-width="80px">
            <el-row>
              <el-col :span="5">
                <el-form-item :label="$t('fn_120')" prop="status">
                  <el-select
                    clearable
                    :placeholder="$t('CK_KS_38')"
                    v-model="queryParams.status"
                  >
                    <el-option :label="$t('fn_130')" value="1"></el-option>
                    <el-option :label="$t('fn_129')" value="2"></el-option>
                    <el-option
                      :label="$t('ENU_APPROVE_S_4')"
                      value="3"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item :label="$t('MN_F_9')" prop="status">
                  <el-select
                    clearable
                    v-model="queryParams.type"
                    :placeholder="$t('MN_F_T_1215')"
                  >
                    <el-option
                      v-for="item in businesstypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item
                  :label="$t('MN_F_T_707')"
                  prop="teamCode"
                  style="margin-bottom: 15px"
                >
                  <el-date-picker
                    v-model="thetime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    :range-separator="$t('w_0139')"
                    :start-placeholder="$t('CK_KS_4')"
                    :end-placeholder="$t('CK_KS_5')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <div class="searchbox">
                  <el-button class="btn2" @click="research">{{
                    $t("N_I_183")
                  }}</el-button>
                  <el-button class="btn1" @click="reset">{{
                    $t("CK_KS_6")
                  }}</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="topbox-cz">
          <div class="">
            <el-button class="topbtn" @click="zzShow = true">{{
              $t("fn_124")
            }}</el-button>
          </div>
        </div>
        <div class="tablebox">
          <el-table
            height="1351px"
            :data="tableData"
            :header-cell-style="{ background: '#EEEEEE' }"
            v-loading="loading"
          >
            <!-- :row-class-name="tableRowClassName" -->
            <el-table-column
              align="center"
              prop="typeVal"
              :label="$t('MN_F_9')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="content"
              :label="$t('MY_CK_10')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="status"
              width="200"
              :label="$t('fn_120')"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.status === 3 && scope.row.rejectInfo"
                  class="tooltip-wrapper"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.rejectInfo"
                    placement="top"
                  >
                    <el-tag type="danger" size="mini">{{
                      $t("ENU_APPROVE_S_4")
                    }}</el-tag>
                  </el-tooltip>
                </div>
                <div v-else>
                  <el-tag
                    v-if="scope.row.status === 1"
                    type="warning"
                    size="mini"
                    >{{ $t("fn_130") }}</el-tag
                  >
                  <el-tag
                    v-else-if="scope.row.status === 2"
                    type="success"
                    size="mini"
                    >{{ $t("fn_129") }}</el-tag
                  >
                  <el-tag
                    v-else-if="scope.row.status === 3"
                    type="danger"
                    size="mini"
                    >{{ $t("ENU_APPROVE_S_4") }}</el-tag
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="creationTime"
              :label="$t('fn_123')"
            ></el-table-column>
          </el-table>
          <pagination
            :total="total"
            :page.sync="pageNum"
            :limit.sync="pageSize"
            @pagination="research"
          />
        </div>
      </div>
    </div>
    <!-- 业务申请 -->
    <el-dialog
      :title="$t('fn_124')"
      :visible.sync="zzShow"
      width="40%"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div class="diaBox2">
        <el-form
          :model="zzform"
          :rules="zzrules"
          label-width="auto"
          ref="zzform"
        >
          <el-form-item :label="$t('MN_F_9')" prop="type">
            <el-select
              v-model="zzform.type"
              :placeholder="$t('MN_F_9')"
            >
              <el-option
                v-for="item in businesstypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('MY_CK_10')" prop="content">
            <el-input
              v-model="zzform.content"
              type="textarea"
              :rows="4"
              resize="none"
              :placeholder="$t('MY_CK_10')"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center">
          <el-button
            @click="handleClose"
            style="width: 117px; font-size: 16px"
            >{{ $t("ENU_P_TYPE0") }}</el-button
          >
          <el-button
            style="width: 117px; font-size: 16px"
            class="saveBtn"
            type="primary"
            @click="saveZz"
            >{{ $t("MY_WAL_23") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import user from "@/store/modules/user";
import { mapGetters } from "vuex";
import * as api from "@/api/index";
export default {
  name: "personalServices",
  data() {
    return {
      totals: [],
      marketList: [
        {
          text: this.$t("ENU_MENU_540"),
          id: 3,
          path: "/marketDynamics",
          name: "bonusSource",
          isShow: false,
        },
      ],
      specialArea: 0,
      thetime: "",
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 15,
      money: 0.0,
      businesstypeList: [], //业务类型列表
      queryParams: {
        type: "",
        status: "",
        startCreateDate: "",
        endCreateDate: "",
      },
      zzrules: {
        type: [
          {
            required: true,
            message: this.$t("S_C_70") + this.$t("MN_F_9"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("S_C_70") + this.$t("MY_CK_10"),
            trigger: "blur",
          },
        ],
      },
      loading: true,
      zzShow: false,
      zzform: {
        type: "",
        memberCode: "",
        content: "",
      },
    };
  },
  watch: {
    $route(n, o) {
      this.specialArea = n.query.id;
    },
  },
  computed: {
    user() {
      return user;
    },
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.getbusinessTypeList();
  },
  mounted() {
    this.specialArea = this.$route.query.id;
    this.research();
    this.getMenuLists();
  },
  methods: {
    getbusinessTypeList() {
      api.personalApplyPersonaltype().then((res) => {
        this.businesstypeList = res.data;
      });
    },
    saveZz() {
      this.$refs["zzform"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          api.personalApply(this.zzform).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.research();
              this.zzShow = false;
              this.$nextTick(() => {
                this.$refs.zzform.resetFields();
              });
            }
          });
        }
      });
    },
    handleClose() {
      this.zzShow = false;
      this.$nextTick(() => {
        this.$refs.zzform.resetFields();
      });
    },
    getMenuLists() {
      let lists = JSON.parse(localStorage.getItem("menuList"));
      lists.forEach((item) => {
        if (this.marketList[0].name == item.menuKey) {
          this.marketList[0].isShow = true;
        }
      });
    },
    dateHref(item) {
      if (this.marketList[0].isShow == true) {
        this.$router.push({
          path: "/marketDynamics",
          query: {
            id: 3,
            index: 1,
          },
        });
      }
    },
    goSource() {
      this.$router.push({
        path: "/marketDynamics",
        query: {
          id: 3,
        },
      });
    },
    changeArea(item) {
      this.specialArea = item.id;
      //   this.research()
      this.$router.push({
        path: item.path,
        query: {
          id: item.id,
        },
      });
    },
    reset() {
      this.tableData = [];
      this.thetime = "";
      (this.queryParams = {
        type: "",
        status: "",
        startCreateDate: "",
        endCreateDate: "",
      }),
        this.research();
    },
    research() {
      if (this.thetime) {
        this.queryParams.startCreateDate = this.thetime[0];
        this.queryParams.endCreateDate = this.thetime[1];
      }
      this.loading = true;
      console.log("----");
      api.personalList(this.queryParams, "").then((res) => {
        console.log(res);
        this.loading = false;
        this.total = res.total;
        this.tableData = res.rows;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else if (rowIndex % 2 == 0) {
        return "success-row";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.style1 {
  cursor: pointer;
  text-decoration: underline;
  color: #d61820;
}

.tabletop {
  position: sticky;
  top: 100px; //这个值根据实际情况而定
  z-index: 10;
  background-color: #fff;
}

:deep(.el-table) {
  overflow: visible;
}

:deep(.el-table__header-wrapper) {
  position: sticky;
  top: 150px; //这个值根据实际情况而定
  z-index: 10;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100%;
  height: 32px;
  padding: 0 10px;
}

::v-deep .select .el-input--suffix .el-input__inner {
  height: 32px;
}

::v-deep .el-table .warning-row {
  background: #f9f9f9;
}

::v-deep .el-table .success-row {
  background: #ffffff;
}

::v-deep .el-table thead {
  color: #000000;
  font-size: 14px;
}

.contain {
  background: rgba(249, 249, 249, 1);
  height: 100vh;
  padding: 47px 62px 47px 0;

  //display: flex;
  .goodArea {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    width: 100%;
    height: 80px;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);

    .goodArea_i {
      margin: 0 35px;
      text-align: center;
      cursor: pointer;
    }

    .actArea {
      color: #b42b2a;
    }
  }

  .topbox {
    // height: 109px;
    width: 100% !important;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(204, 204, 204, 0.5);
    border-radius: 8px 8px 8px 8px;
    margin: 20px 0 0 0;
    padding: 15px 0 0 0;

    .searchbox {
      display: flex;
      align-items: center;
      margin-left: 40px;

      .btn1 {
        border: 1px solid #cccccc;
        border-radius: 5px 5px 5px 5px;
        color: #666;
        height: 34px;
        width: 68px;
        padding: 0;
      }

      .btn2 {
        border-radius: 5px 5px 5px 5px;
        background: rgba(214, 24, 32, 1);
        color: #ffffff;
        height: 34px;
        width: 68px;
        padding: 0;
      }
    }
  }

  .tablebox {
    box-shadow: 0px 2px 20px 0px rgba(135, 135, 135, 0.3);
    border-radius: 10px 10px 10px 10px;
    margin-top: 20px;

    .tabletop {
      text-align: right;
      padding: 20px;

      .tabletoptitle1 {
        font-size: 18px;
      }

      .tabletoptitle2 {
        font-size: 24px;
        font-weight: 600;
      }
    }
  }
}

.top-lists {
  display: flex;
  padding: 0 0 0 0;
  margin-top: -30px;
  .nav-view {
    cursor: pointer;
    padding: 0 26px;
    height: 44px;
    border-radius: 10px;
    border: 1px solid #999999;
    font-size: 14px;
    text-align: center;
    line-height: 44px;
    margin-right: 20px;
    color: #999;
  }
}

.styles {
  border: none !important;
  color: #fff !important;
  background: #d61820 !important;
}
.topbox-cz {
  // height: 109px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(204, 204, 204, 0.5);
  border-radius: 8px 8px 8px 8px;
  margin: 20px 0 0px 0;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .topbtn {
    border: 1px solid #cccccc;
    border-radius: 10px;
    // background: red;
  }

  .topbtn:hover,
  .topbtn:active,
  .topbtn.is-active,
  .topbtn:focus {
    background-color: rgba(192, 31, 31, 1);
    color: #ffffff;
  }
}
</style>
